import { Icon, IconProps } from "@src/components/deprecated/Icon/Icon";
import { ReactComponent as InfoIcon } from "@svg/info.svg";
import { CSSProperties, ReactNode } from "react";
import { PopupPosition } from "reactjs-popup/dist/types";
import styles from "./DeprecatedTooltip.module.css";
import { TooltipWrapper } from "./TooltipWrapper";

type Props = {
  title: string;
  direction?: PopupPosition | PopupPosition[];

  customIcon?: IconProps;

  contentStyle?: CSSProperties;

  marginTop?: string | number;
  marginRight?: string | number;
  marginBottom?: string | number;
  marginLeft?: string | number;

  children?: ReactNode;
};

/**
 * @deprecated use Tooltip from @src/components/ui-components/Tooltip/Tooltip.tsx
 */
export const DeprecatedTooltip = ({
  title,
  customIcon,
  contentStyle,
  direction,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  children,
}: Props) => {
  let style: CSSProperties = {
    ...contentStyle,
    ...(marginTop && { marginTop }),
    ...(marginRight && { marginRight }),
    ...(marginBottom && { marginBottom }),
    ...(marginLeft && { marginLeft }),
  };

  return (
    <TooltipWrapper
      title={title}
      trigger={
        <div className={styles.buttonContainer} style={style}>
          {customIcon ? <Icon {...customIcon} /> : <InfoIcon width={"16px"} height="16px" color="#A19EA8" />}
        </div>
      }
      direction={direction}
    >
      {children}
    </TooltipWrapper>
  );
};

